// src/services/apiService.js
import axios from "axios";

const API_BASE_URL ="https://apikyc.vkstockvission.in/api";                                  // "http://72.60.99.84/api";                   //"http://localhost:4000/api";  // "https://stockmantra.onrender.com/api"; // ⚙️ change for production

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

// 1️⃣ SEND OTP
export const sendOtp = async (email) => {
  const res = await api.post("/otp/send", { email });
  return res.data;
};

// 2️⃣ VERIFY OTP
export const verifyOtp = async (email, otp) => {
  const res = await api.post("/otp/verify", { email, otp });
  return res.data;
};

// 3️⃣ FORM SUBMISSION (multipart with PAN + AADHAAR)
export const submitForm = async (formData) => {
  const res = await axios.post(`${API_BASE_URL}/submit`, formData, {
  // const res = await axios.post(`/api/submit`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

// 4️⃣ SEND AGREEMENT EMAIL (📩 email body + signer audit metadata)
// Accepts either a bare email string (back-compat) or a payload object
// { email, ipAddress, location, lat, lng } captured at acceptance time.
export const sendAgreement = async (payload) => {
  const body = typeof payload === "string" ? { email: payload } : payload;
  const res = await api.post("/send-agreement", body);
  return res.data;
};

// 5️⃣ OPEN INVOICE (in browser tab)
export const openInvoice = (txnId) => {
  window.open(`${API_BASE_URL}/invoice/${txnId}`, "_blank");
};

export default {
  sendOtp,
  verifyOtp,
  submitForm,
  sendAgreement,
  openInvoice,
};
